module.exports = __webpack_public_path__ + "static/media/pawritten.a5b98d34.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten.woff2
// module id = ./src/assets/fonts/pawritten.woff2
// module chunks = 0